import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { DriverMetricAdjustmentCreateInput } from '../generated/globalTypes';
import { createDriverMetricAdjustmentMutation, createDriverMetricAdjustmentMutationVariables } from '../generated/createDriverMetricAdjustmentMutation';
import { driverMetricAdjustmentFieldsFragment } from '../models/DriverMetricAdjustment';

/**
 * Get a callback to create a DriverMetricAdjustment in the store.
 */
export function useCreateDriverMetricAdjustmentCallback(): [(model: DriverMetricAdjustmentCreateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<createDriverMetricAdjustmentMutation, createDriverMetricAdjustmentMutationVariables>(
        gql`
            mutation createDriverMetricAdjustmentMutation ($model: DriverMetricAdjustmentCreateInput!) {
                createDriverMetricAdjustment(model: $model) {
                    ...driverMetricAdjustmentFields
                }
            }

            ${driverMetricAdjustmentFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (model: DriverMetricAdjustmentCreateInput) => {
        const result = await mutationAction({ variables: { model: model } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
